const getUri = () =>
  `${window.location.pathname}${window.location.search}${window.location.hash}`;

export function getLoginURL(state: string = getUri()) {
  return `/api/login?${new URLSearchParams({ state })}`;
}

export function getLogoutURL() {
  return "/api/logout";
}

export function getVerifyURL(state: string = getUri()) {
  return `/auth/verify?${new URLSearchParams({ state })}`;
}
